module.exports = __webpack_public_path__ + "static/media/L.8bebce2c.jpg";